import {tApi} from 'tplus-api';


//param post参数  method 方法  isJsonString 是否转换为json字符串  isFree 是否需要认证信息
const tplusAjaxReq = tApi;

const webapiProxyReq = tApi;

export {tplusAjaxReq,webapiProxyReq}